import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'validate.js';

const FROM_GOOD_DOG_ITEMS = [
  'Lifetime support from Good Dog’s Care Team',
  '10% lifetime discount on Figo pet insurance',
  'Puppy Training Program & private community'
];

const DEFAULT_HEALTH_PRACTICES = [
  'Vet check',
  'First round of shots and deworming'
];

const HEALTH_PRACTICE_EXTRAS = ['Microchip', 'Vet records', 'Vaccinations'];

export const WHATS_INCLUDED_KEYS = {
  GOOD_DOG: 'whats-included-from-good-dog',
  ENRICHMENT_SOCIALIZATION: 'whats-included-enrichment-socialization',
  HEALTH: 'whats-included-puppy-health-practices',
  EXTRAS: 'whats-included-extras'
};

export default function useIncludedItems() {
  const { breederPuppyExtras = [], breederTrainingPrograms } = useSelector(
    ({ server }) => server
  );

  return useMemo(() => {
    const { healthPractices, puppyExtras } = breederPuppyExtras.reduce(
      (acc, extra) => {
        if (HEALTH_PRACTICE_EXTRAS.includes(extra)) {
          acc.healthPractices.add(extra);
        } else {
          acc.puppyExtras.add(extra);
        }

        return acc;
      },
      {
        healthPractices: new Set([...DEFAULT_HEALTH_PRACTICES]),
        puppyExtras: new Set()
      }
    );

    return [
      !isEmpty(FROM_GOOD_DOG_ITEMS) && {
        id: WHATS_INCLUDED_KEYS.GOOD_DOG,
        title: 'From Good Dog',
        items: FROM_GOOD_DOG_ITEMS,
        iconName: 'fetch-pets-heart'
      },
      !isEmpty(breederTrainingPrograms) && {
        id: WHATS_INCLUDED_KEYS.ENRICHMENT_SOCIALIZATION,
        title: 'Enrichment & socialization',
        items: breederTrainingPrograms,
        iconName: 'fetch-cat-dog'
      },
      healthPractices.size > 0 && {
        id: WHATS_INCLUDED_KEYS.HEALTH,
        title: 'Puppy health practices',
        items: Array.from(healthPractices),
        iconName: 'fetch-health-verified'
      },
      puppyExtras.size > 0 && {
        id: WHATS_INCLUDED_KEYS.EXTRAS,
        title: 'Extras',
        items: Array.from(puppyExtras),
        iconName: 'fetch-gift'
      }
    ].filter(Boolean);
  }, []);
}
